<template>
    <div class="profile-sidebar">
        <div class="widget-profile pro-widget-content">
            <div class="profile-info-widget">
                <a href="#" class="booking-doc-img">
                    <img src="@/assets/img/schools/school-1.jpg" alt="User Image">
                </a>
                <div class="profile-det-info">
                    <h3>Camestone School</h3>
                    
                    <div class="receiver-details">
                        <h5 class="mb-0">4 Jowitt Ave, Kempston, Bedford MK42 8NW, United States</h5>
                    </div>
                </div>
            </div>
        </div>
        <div class="dashboard-widget">
            <nav class="dashboard-menu">
                <ul>
                    <li v-bind:class="{'active': currentPath == 'school-dashboard'}">
                        <router-link to="/dashboard">
                            <i class="fas fa-columns"></i>
                            <span>Dashboard</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'course-list'}">
                        <router-link to="/course">
                            <i class="fas fa-calendar-check"></i>
                            <span>Courses</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'instructors'}">
                        <router-link to="/instructors">
                            <i class="fas fa-user-graduate"></i>
                            <span>My Instructors</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'schedule-timings'}">
                        <router-link to="/schedule-timings">
                            <i class="fas fa-hourglass-start"></i>
                            <span>Schedule Timings</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'invoices'}">
                        <router-link to="/invoices">
                            <i class="fas fa-file-invoice"></i>
                            <span>Invoices</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'instructor-reviews'}">
                        <router-link to="/instructor/reviews">
                            <i class="fas fa-star"></i>
                            <span>Reviews</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'instructor-chat'}">
                        <router-link to="/instructor/chat">
                            <i class="fas fa-comments"></i>
                            <span>Message</span>
                            <small class="unread-msg">23</small>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'school-profile-settings'}">
                        <router-link to="/profile-settings">
                            <i class="fas fa-user-cog"></i>
                            <span>Profile Settings</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'school-social-media'}">
                        <router-link to="/social-media">
                            <i class="fas fa-share-alt"></i>
                            <span>Social Media</span>
                        </router-link>
                    </li>
                    <li v-bind:class="{'active': currentPath == 'school-change-password'}">
                        <router-link to="/change-password">
                            <i class="fas fa-lock"></i>
                            <span>Change Password</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/index">
                            <i class="fas fa-sign-out-alt"></i>
                            <span>Logout</span>
                        </router-link>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<script>
export default {
    computed:{
        currentPath() {
            return this.$route.name
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/School/Sidebar/index.vue